import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { qrConnectCharmText } from './QrConnectCharm.locstring.json';
import { lazyDisplayQRCode } from 'owa-qrcode';
import HeaderCharm from './HeaderCharm';
import { ControlIcons } from 'owa-control-icons';
import { HeaderCharmType } from 'owa-header-store';
import loc from 'owa-localize';

export default observer(function QrConnectCharm(props: {}) {
    const charmDiv = React.useRef<HTMLButtonElement>();

    return (
        <HeaderCharm
            ref={charmDiv}
            key="qrconnect"
            icons={{
                iconName: ControlIcons.QRCode,
                hoverIconName: ControlIcons.QRCode,
            }}
            title={loc(qrConnectCharmText)}
            ariaLabel={loc(qrConnectCharmText)}
            behavior={{
                isActive: false,
                content: undefined,
                onClick: onClick,
                charm: HeaderCharmType.QrConnectCharm,
            }}
        />
    );
});

function onClick() {
    lazyDisplayQRCode.importAndExecute('headercharm');
}
